/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Fund_HeadingInputs */

const en_onboarding_v1_fund_heading = /** @type {(inputs: Onboarding_V1_Fund_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fund your portfolio`)
};

const de_onboarding_v1_fund_heading = /** @type {(inputs: Onboarding_V1_Fund_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portfolio finanzieren`)
};

const pt_br2_onboarding_v1_fund_heading = /** @type {(inputs: Onboarding_V1_Fund_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposite no seu portfólio`)
};

const tr_onboarding_v1_fund_heading = /** @type {(inputs: Onboarding_V1_Fund_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portföyüne para yatır`)
};

const zh_cn2_onboarding_v1_fund_heading = /** @type {(inputs: Onboarding_V1_Fund_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为投资组合注资`)
};

const zh_hk2_onboarding_v1_fund_heading = /** @type {(inputs: Onboarding_V1_Fund_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`為投資組合注資`)
};

const ko_kr2_onboarding_v1_fund_heading = /** @type {(inputs: Onboarding_V1_Fund_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포트폴리오에 자금 입금`)
};

const ru_ru2_onboarding_v1_fund_heading = /** @type {(inputs: Onboarding_V1_Fund_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пополните портфель`)
};

const es_419_onboarding_v1_fund_heading = /** @type {(inputs: Onboarding_V1_Fund_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondea tu portafolio`)
};

/**
* | output |
* | --- |
* | "Fund your portfolio" |
*
* @param {Onboarding_V1_Fund_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_fund_heading = /** @type {((inputs?: Onboarding_V1_Fund_HeadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Fund_HeadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_fund_heading(inputs)
	if (locale === "de") return de_onboarding_v1_fund_heading(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_fund_heading(inputs)
	if (locale === "tr") return tr_onboarding_v1_fund_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_fund_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_fund_heading(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_fund_heading(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_fund_heading(inputs)
	return es_419_onboarding_v1_fund_heading(inputs)
});